import { jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Button, IconButton, Menu, MenuItem, styled } from "@mui/material";
import { Icon } from "@blueprintjs/core";
//#region src/menu/index.tsx
function Menu$2({ children, items = [], showAsIcon = false, disableScrollLock = true, minWidth = 160, maxHeight, buttonProps, minWidthButton, endIcon = /* @__PURE__ */ jsx(Icon, { icon: "chevron-down" }), ...props }) {
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	return /* @__PURE__ */ jsxs("div", {
		className: "bs-menu",
		children: [
			!showAsIcon && /* @__PURE__ */ jsx(StyledButton, {
				disableElevation: true,
				variant: "contained",
				endIcon: items.length ? endIcon : null,
				onClick: handleClick,
				className: "bs-menu-button",
				sx: {
					justifyContent: "space-between",
					minWidth: minWidthButton
				},
				...buttonProps,
				children
			}),
			showAsIcon && /* @__PURE__ */ jsx(IconButton, {
				onClick: handleClick,
				className: "bs-menu-button",
				...buttonProps,
				children
			}),
			items.length > 0 && /* @__PURE__ */ jsx(StyledMenu, {
				anchorEl,
				open,
				onClose: handleClose,
				disableScrollLock,
				sx: { ".MuiPaper-root": {
					minWidth,
					maxHeight
				} },
				...props,
				children: items.map((item, index) => /* @__PURE__ */ jsxs(MenuItem, {
					onClick: () => {
						setAnchorEl(null);
						item.onClick && item.onClick();
					},
					children: [item.icon, item.text]
				}, index))
			})
		]
	});
}
var StyledMenu = styled((props) => /* @__PURE__ */ jsx(Menu, {
	elevation: 0,
	anchorOrigin: {
		vertical: "bottom",
		horizontal: "right"
	},
	transformOrigin: {
		vertical: "top",
		horizontal: "right"
	},
	...props
}))({ ".MuiPaper-root": {
	borderRadius: 12,
	border: "1px solid #EEEFF2",
	marginTop: 8,
	color: "#6C6C6C",
	boxShadow: "0px 12px 40px 0px rgba(0, 0, 0, 0.09)",
	".MuiMenu-list": { padding: 0 },
	".MuiMenuItem-root": {
		padding: "12px 24px",
		boxShadow: "0px 1px 0px 0px #F7F7F7",
		fontSize: "16px",
		fontWeight: 400,
		color: "#6C6C6C",
		lineHeight: 1,
		fontFamily: "ploni, sans-serif",
		"&:hover": {
			color: "#404040",
			backgroundColor: "#F8F8F8"
		}
	}
} });
var StyledButton = styled(Button)({
	padding: "12px 16px",
	borderRadius: "12px",
	backgroundColor: "#F8F8F8",
	textTransform: "none",
	fontSize: "16px",
	fontWeight: 400,
	color: "#6C6C6C",
	lineHeight: 1,
	fontFamily: "ploni, sans-serif",
	"&:hover": {
		color: "#FFFFFF",
		backgroundColor: "#307FF6"
	}
});
//#endregion
export { Menu$2 as Menu };

//# sourceMappingURL=index.esm.js.map